<template>
  <div>
    <section v-if="detail != ''" class="container">
      <!-- info -->
      <div class="info">
        <h2>{{ detail.user_name }}</h2>
        <ul class="keyInfo">
          <li>
            <p>{{ detail.age + "岁" }}</p>
          </li>
          <li>
            <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
            <p v-show="detail.gender == 1">男</p>
            <p v-show="detail.gender == 2">女</p>
            <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
          </li>
          <li>
            <p v-show="detail.on_job == 1">在职</p>
            <p v-show="detail.on_job == 0">已离职</p>
          </li>
          <li>
            <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
            <p>{{ detail.phone }}</p>
          </li>
        </ul>
        <ul class="financeInfo" v-show="detail.is_authentication == 1">
          <li>
            <label>身份证号：</label>
            <p>{{ detail.idcard }}</p>
          </li>
          <li>
            <label>银行名称：</label>
            <p>{{ detail.bank_name }}</p>
          </li>
          <li>
            <label>银行卡号：</label>
            <p>{{ detail.bank_card_number }}</p>
          </li>
        </ul>
        <div class="proStyle" v-show="detail.entry_leave_record != ''">
          <h4>项目信息</h4>
          <table>
            <thead>
              <tr>
                <th>项目名称</th>
                <th>是否在职</th>
                <th>入职日期</th>
                <th>来源类型</th>
                <th>来源渠道</th>
                <th>渠道详情</th>
                <th>类型</th>
                <th>状态</th>
                <th>离职日期</th>
                <th>离职是否结算</th>
                <th>合同</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(element, index) in detail.entry_leave_record"
                :key="index"
              >
                <td>{{ element.project_name }}</td>
                <td>
                  <p v-show="element.is_leave == 0">在职</p>
                  <p v-show="element.is_leave == 1">已离职</p>
                </td>
                <td>{{ element.entry_time.substring(0, 10) }}</td>
                <td>{{ element.resume_source_info.type }}</td>
                <td>{{ element.resume_source_info.channel }}</td>
                <td>{{ element.resume_source_info.details }}</td>
                <td>
                  <p v-show="element.work_type == 1">长期工</p>
                  <p v-show="element.work_type == 2">临时工</p>
                </td>
                <td>
                  <p v-show="element.status == 9">待认证</p>
                  <p v-show="element.status == 10">待签约</p>
                  <p v-show="element.status == 11">新合同待签</p>
                  <p v-show="element.status == 20">资料待审核</p>
                  <p v-show="element.status == 31">资料已驳回</p>
                  <p v-show="element.status == 40">已入职</p>
                  <p v-show="element.status == 50">离职合同待签</p>
                  <p v-show="element.status == 51">已离职</p>
                </td>
                <td>
                  <p v-show="element.status == 50 || element.status == 51">
                    {{ element.leave_time.substring(0, 10) }}
                  </p>
                </td>
                <td>
                  <div v-show="element.status == 50 || element.status == 51">
                    <p v-show="element.is_settlement == 2">结算</p>
                    <p v-show="element.is_settlement == 1">不结算</p>
                    <p v-show="element.is_settlement == 0">未知</p>
                  </div>
                </td>
                <td>
                  <a
                    style="color:#2196f3"
                    v-for="(item, k) in element.contract_info"
                    :key="k"
                    :href="item.pdf_url"
                    target="view_window"
                    >{{ k + 1 + "." + item.agreement_name }}</a
                  >
                  <a v-show="element.contract_info == ''">暂无</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 亲属卡 -->
        <div class="operationKinsfolk">
          <a-button
            v-show="detail.is_relatives_card == 2"
            @click="addKinsfolk('添加亲属卡')"
            type="primary"
            value="small"
            ghost
          >
            添加亲属卡
          </a-button>
          <a-button
            v-show="detail.is_relatives_card == 1"
            @click="addKinsfolk('更换亲属卡')"
            type="primary"
            value="small"
            ghost
          >
            更换亲属卡
          </a-button>
        </div>
        <ul class="financeInfo" v-if="detail.is_relatives_card == 1">
          <li>
            <label>亲属姓名：</label>
            <p>{{ detail.relatives_card_info.name }}</p>
          </li>
          <li>
            <label>亲属关系：</label>
            <p>{{ detail.relatives_card_info.relationship }}</p>
          </li>
          <li>
            <label>亲属手机号：</label>
            <p>{{ detail.relatives_card_info.phone }}</p>
          </li>
          <li>
            <label>亲属身份证号：</label>
            <p>{{ detail.relatives_card_info.idcard }}</p>
          </li>
          <li>
            <label>亲属银行卡号：</label>
            <p>{{ detail.relatives_card_info.bank_card_number }}</p>
          </li>
          <li>
            <label>添加时间：</label>
            <p>{{ detail.relatives_card_info.create_time }}</p>
          </li>
          <li>
            <label>更改时间：</label>
            <p>{{ detail.relatives_card_info.update_time }}</p>
          </li>
        </ul>
        <!-- 亲属卡 end-->
      </div>
      <!-- info end -->

      <!-- 身份证 -->
      <div
        class="operationLog"
        v-show="idcard_img_front.length > 0 || idcard_img_back.length > 0"
      >
        <h4>身份证照片</h4>
        <ul class="IDImgStyle">
          <li>
            <viewer :images="idcard_img_front" class="imgStyle">
              <img v-for="src in idcard_img_front" :src="src" :key="src" />
            </viewer>
          </li>
          <li>
            <viewer :images="idcard_img_back" class="imgStyle">
              <img v-for="src in idcard_img_back" :src="src" :key="src" />
            </viewer>
          </li>
        </ul>
      </div>
      <!-- 身份证 end -->
      <!-- 入离职记录 -->
      <div class="operationLog" v-show="detail.entry_leave_record != ''">
        <h4>入离职操作记录</h4>
        <a-timeline>
          <a-timeline-item
            v-for="(item, index) in detail.entry_leave_record"
            :key="index"
            :color="item.is_leave == 1 ? 'red' : 'green'"
          >
            <ul class="operationLog-list">
              <li>
                <label>入职项目：</label>
                <p>{{ item.project_name }}</p>
              </li>
              <li v-show="item.shop_info != ''">
                <label>入职门店/区域/大仓：</label>
                <p>{{ item.shop_info.name }}</p>
              </li>
              <li v-show="item.shop_info != ''">
                <label>地址：</label>
                <p>
                  {{
                    item.shop_info.province +
                      item.shop_info.city +
                      item.shop_info.area +
                      item.shop_info.address
                  }}
                </p>
              </li>
              <li>
                <label>入职岗位：</label>
                <p>{{ item.guard_role_names }}</p>
              </li>
              <li>
                <label>工作类型：</label>
                <p v-show="item.work_type == 1">长期工</p>
                <p v-show="item.work_type == 2">临时工</p>
              </li>
              <li>
                <label>来源类型：</label>
                <p>
                  {{
                    item.resume_source_info == undefined
                      ? ""
                      : item.resume_source_info.type
                  }}
                </p>
              </li>
              <li v-if="item.resume_source_info != undefined">
                <label>来源渠道：</label>
                <p>
                  {{
                    item.resume_source_info == undefined
                      ? ""
                      : item.resume_source_info.channel
                  }}
                </p>
              </li>
              <li v-if="item.resume_source_info != undefined">
                <label>来源账号：</label>
                <p>
                  {{
                    item.resume_source_info == undefined
                      ? ""
                      : item.resume_source_info.details
                  }}
                </p>
              </li>
              <li>
                <label>入职日期：</label>
                <p>{{ item.entry_time }}</p>
              </li>
              <li>
                <label>入职操作时间：</label>
                <p>{{ item.create_time }}</p>
              </li>
              <li>
                <label>入职操作人员：</label>
                <p>{{ item.entry_user_name }}</p>
              </li>
              <li>
                <label>项目状态：</label>
                <p v-show="item.status == 9">待认证</p>
                <p v-show="item.status == 10">待签约</p>
                <p v-show="item.status == 11">新合同待签</p>
                <p v-show="item.status == 20">资料待审核</p>
                <p v-show="item.status == 31">资料审核驳回</p>
                <p v-show="item.status == 40">已入职</p>
                <p v-show="item.status == 50">离职合同待签</p>
                <p v-show="item.status == 51">已离职</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职时间：</label>
                <p>{{ item.leave_time }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职操作时间：</label>
                <p>{{ item.leave_create_time }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职操作人员：</label>
                <p>{{ item.leave_user_name }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职原因：</label>
                <p>{{ item.reason }}</p>
              </li>
              <li v-show="item.status == 51 || item.status == 50">
                <label>离职是否结算：</label>
                <p v-show="item.is_settlement == 1">不结算</p>
                <p v-show="item.is_settlement == 2">结算</p>
              </li>
            </ul>
          </a-timeline-item>
        </a-timeline>
      </div>
      <!-- 入离职记录 end -->
      <!-- 资料审核记录 -->
      <div
        class="operationLog"
        v-show="detail.is_authentication == 1 || detail.log_record != ''"
      >
        <h4>认证签约记录</h4>
        <a-timeline>
          <a-timeline-item>
            <ul class="operationLog-list">
              <li><h3>实名认证</h3></li>
              <br />
              <li>
                <p>操作时间：</p>
                <p>{{ detail.identity_create_time }}</p>
              </li>
            </ul>
          </a-timeline-item>
          <a-timeline-item
            v-for="(item, index) in detail.log_record"
            :key="index"
          >
            <ul class="operationLog-list">
              <li>
                <h3 v-show="item.type == 1">签约</h3>
                <h3 v-show="item.type == 2">审核通过</h3>
                <h3 v-show="item.type == 3">审核驳回</h3>
              </li>
              <br />
              <li v-show="item.type != 1">
                <p>操作人员：</p>
                <p>{{ item.role_name + "-" + item.operation_user_name }}</p>
              </li>
              <li>
                <p>操作时间：</p>
                <p>{{ item.create_time }}</p>
              </li>
              <li v-show="item.remark != '' && item.type != 1">
                <p>操作备注：</p>
                <p>{{ item.remark }}</p>
              </li>
            </ul>
          </a-timeline-item>
        </a-timeline>
      </div>
      <!-- 资料审核记录 end -->
      <!-- 亲属卡修改记录 -->
      <!-- <div class="operationLog" v-show="detail.relatives_card_info != ''">
        <h4>亲属卡修改记录</h4>
        <a-timeline>
          <a-timeline-item
            v-for="(item, index) in detail.relatives_card_info"
            :key="index"
          >
            <ul class="operationLog-list">
              <li>
                <h3>{{ item.create_time }}</h3>
              </li>
              <br />
              <li>
                <p>亲属姓名：</p>
                <p>{{ item.name }}</p>
              </li>
              <li>
                <p>亲属手机号：</p>
                <p>{{ item.phone }}</p>
              </li>
              <li>
                <p>亲属关系：</p>
                <p>{{ item.create_time }}</p>
              </li>
              <li>
                <p>亲属身份证号：</p>
                <p>{{ item.idcard }}</p>
              </li>
              <li>
                <p>亲属银行卡号：</p>
                <p>{{ item.bank_card_number }}</p>
              </li>
              <li>
                <p>亲属关系：</p>
                <p>{{ item.create_time }}</p>
              </li>
            </ul>
          </a-timeline-item>
        </a-timeline>
      </div> -->
      <!-- 亲属卡修改记录 end -->
    </section>

    <!-- 亲属卡 -->
    <aside class="dialogsBox" v-show="showIsKinsfolk">
      <div>
        <h3>{{ kinsfolkTitle }}</h3>
        <a @click="rejectCancel" class="close">
          <a-icon type="close-circle" style="font-size:30px;color:#333" />
        </a>
        <ul v-if="detail != ''">
          <li>
            <label>员工姓名：</label>
            <p>{{ detail.user_name }}</p>
          </li>
          <li>
            <label>员工手机号：</label>
            <p>{{ detail.phone }}</p>
          </li>
          <li>
            <label><i>*</i>亲属关系：</label>
            <a-input v-model="kinsfolk.relationship" style="width:60%" />
          </li>
          <li>
            <label><i>*</i>姓名：</label>
            <a-input v-model="kinsfolk.name" style="width:60%" />
          </li>
          <li>
            <label><i>*</i>手机号：</label>
            <a-input v-model="kinsfolk.phone" style="width:60%" />
          </li>
          <li>
            <label><i>*</i>身份证号：</label>
            <a-input v-model="kinsfolk.idcard" style="width:60%" />
          </li>
          <li>
            <label><i>*</i>银行卡号：</label>
            <a-input v-model="kinsfolk.bank_card_number" style="width:60%" />
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="submitKinsfolk">
            提交
          </a-button>
        </div>
      </div>
    </aside>
    <!-- 亲属卡 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      showIsKinsfolk: false,
      kinsfolk: {
        relationship: "",
        name: "",
        phone: "",
        idcard: "",
        bank_card_number: ""
      },
      idcard_img_front: [],
      idcard_img_back: [],
      kinsfolkTitle: "添加亲属卡"
    };
  },
  props: {
    workerId: {}
  },
  watch: {
    workerId() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.workerId != undefined && this.workerId != "") {
      this.getDetail();
    }
  },
  methods: {
    verify() {
      let fls = true;
      if (this.kinsfolk.relationship == "") {
        fls = false;
        this.$message.warning("请填写亲属关系!");
        return fls;
      }
      if (this.kinsfolk.name == "") {
        fls = false;
        this.$message.warning("请填写亲属姓名!");
        return fls;
      }
      if (this.kinsfolk.phone == "") {
        fls = false;
        this.$message.warning("请填写亲属手机号!");
        return fls;
      }
      if (this.kinsfolk.idcard == "") {
        fls = false;
        this.$message.warning("请填写身份证号!");
        return fls;
      }
      if (this.kinsfolk.idcard.length != 18) {
        this.$message.warning("请输入正确的身份证号");
        fls = false;
        return fls;
      }
      if (this.kinsfolk.bank_card_number == "") {
        fls = false;
        this.$message.warning("请填写银行卡号!");
        return fls;
      }
      if (this.kinsfolk.bank_card_number.length < 16) {
        this.$message.warning("请输入正确的银行卡号");
        fls = false;
        return fls;
      }
      if (this.kinsfolk.bank_card_number.length > 19) {
        this.$message.warning("请输入正确的银行卡号");
        fls = false;
        return fls;
      }
      return fls;
    },
    submitKinsfolk() {
      let fls = this.verify();
      if (fls) {
        this.kinsfolkTitle == "添加亲属卡"
          ? this.submitAddKinsfolk()
          : this.submitEditKinsfolk();
      }
    },
    submitAddKinsfolk() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "User_relatives_card/addRelativesCard";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        user_id: this.detail.user_id,
        relationship: this.kinsfolk.relationship,
        name: this.kinsfolk.name,
        phone: this.kinsfolk.phone,
        idcard: this.kinsfolk.idcard,
        bank_card_number: this.kinsfolk.bank_card_number
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("亲属卡已添加");
          this.showIsKinsfolk = false;
          this.getDetail();
          // console.log(res.data);
        } else {
          this.$error({
            title: "验证出错，添加失败",
            content: "原因：" + res.data.message
          });
        }
      });
    },
    submitEditKinsfolk() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "User_relatives_card/editRelativesCard";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        user_id: this.detail.user_id,
        relationship: this.kinsfolk.relationship,
        name: this.kinsfolk.name,
        phone: this.kinsfolk.phone,
        idcard: this.kinsfolk.idcard,
        bank_card_number: this.kinsfolk.bank_card_number
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.$message.success("亲属卡已更改");
          this.showIsKinsfolk = false;
          this.getDetail();
          // console.log(res.data);
        } else {
          this.$error({
            title: "验证出错，添加失败",
            content: "原因：" + res.data.message
          });
        }
      });
    },
    rejectCancel() {
      this.showIsKinsfolk = false;
    },
    addKinsfolk(title) {
      this.kinsfolkTitle = title;
      this.showIsKinsfolk = true;
    },
    getDetail() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/guardLsitDetails";
      axios
        .post(url, {
          user_id: this.workerId,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detail = res.data.data;
            this.idcard_img_front = [];
            this.idcard_img_back = [];
            if (this.detail.idcard_img_front != "") {
              this.idcard_img_front.push(this.detail.idcard_img_front);
            }
            if (this.detail.idcard_img_back) {
              this.idcard_img_back.push(this.detail.idcard_img_back);
            }
            // console.log(res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 30px 3%;
  .proStyle {
    margin-top: 20px;
    h4 {
      margin-bottom: 10px;
      font-size: 16px;
    }
    table {
      min-width: 30%;
      margin-bottom: 30px;
      td,
      th {
        border: 1px solid #ccc;
        font-size: 14px;
        line-height: 20px;
        padding: 4px 10px;
      }
      a {
        display: block;
        font-size: 14px;
        line-height: 20px;
      }
      th {
        background: #ededed;
      }
    }
  }
  .info {
    .keyInfo {
      li {
        display: inline-block;
        p {
          display: inline-block;
        }
      }
    }
    .financeInfo {
      margin: 10px 0;
      li {
        display: inline-block;
        width: 33.3%;
        margin-bottom: 20px;
        p,
        label {
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          line-height: 20px;
        }
        .imgStyle {
          display: inline-block;
          vertical-align: top;
          img {
            height: 80px;
            width: 80px;
            object-fit: cover;
          }
        }
      }
    }
  }
  .steps {
    width: 100%;
  }
  .description {
    width: 100%;
    > li {
      display: inline-block;
      min-width: 33.3%;
      p,
      label {
        display: inline-block;
      }
    }
  }
  .dialogsBox > div {
    margin-top: 100px;
  }
  .operationKinsfolk {
    margin-bottom: 20px;
  }
  .operationLog {
    h4 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    .operationLog-list {
      > li {
        display: inline-block;
        min-width: 30%;
        margin-right: 20px;
        margin-bottom: 10px;
        p,
        label {
          display: inline-block;
          font-size: 14px;
          line-height: 20px;
          vertical-align: top;
        }
        p {
          max-width: 80%;
        }
      }
    }
  }
  .IDImgStyle {
    margin-bottom: 30px;
    li {
      display: inline-block;
      margin-right: 30px;
      img {
        width: 100px;
        height: 100px;
        object-fit: cover;
      }
    }
  }
}
.dialogsBox {
  > div {
    margin-top: 100px;
  }
}
.info {
  h2 {
    margin-bottom: 20px;
  }
}
</style>
